export default {
  methods: {
    show() { this.$refs.dialog.show() },
    hide() { this.$refs.dialog.hide() },
    onDialogHide() { this.$emit('hide') },
    onCancelClick() { this.hide() },
    onOKClick() {
      this.$emit('ok')
      this.hide()
    },
  },
}
